export const demoData = {
  version: 1.0,
  title: "AdobeCC Demo",
  flows: [
    {
      id: 0,
      sections: [
        {
          id: 0,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["AdobeCC_Step0_Titlecard.jpg"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
      ],
    },
    {
      id: 1,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Pin assets to tabs",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text:
              "Users can share work, get feedback, and stay up to date on creative assets within Teams channels with the Adobe Creative Cloud app.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "81.5%",
              x: "87.1%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["AdobeCC_Step1a_Image1a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "Head to the Teams icon to start collaborating",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "10.8%",
              x: "0.9%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeCC_Step1a_Image1b.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText:
            "From a Teams channel a user navigates to a vertical icon bar on the left side of the screen. The icon bar lists ten icons. Activity, Chat, Teams, Calendar, Calls, Files, Adobe Creative Cloud, and an ellipsis are at the top. The App and Help icons are at the bottom. A purple pop-up points to the Teams icon.",
        },
        {
          id: 3,
          card: {
            transition: false,
            text: "Select the channel where you want to share the asset",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "26.5%",
              x: "8.8%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeCC_Step1a_Image2.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText:
            "A Teams channel titled “Event Planning” is now open. To the left-hand side of the Event Planning Teams channel, there’s a vertical list of Teams channels. A purple pop-up points to the Event Planning channel.",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "Add a tab",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "6%",
              x: "59.8%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["AdobeCC_Step1a_Image3.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText:
            "A white box appears with a header that reads “Add a tab” There is a grid style list of available apps. A purple pop-up points to the Adobe Creative Cloud icon on the list.",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "Select Adobe Creative Cloud from the list of apps",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "26%",
              x: "33.5%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeCC_Step1a_Image4.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A new white box appears titled “Adobe Creative Cloud”. A purple pop-up points to a button that reads “Sign in with Adobe ID”. ",
        },
        {
          id: 5,
          card: {
            transition: false,
            text: "Sign in to start browsing creative assets",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "47.5%",
              x: "48.8%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["AdobeCC_Step1a_Image5.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A new box appears prompting the user to sign in. A purple pop-up points to a field titled “email address”",
        },
        {
          id: 6,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "30.5%",
              x: "43.8%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["AdobeCC_Step1a_Image6a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText: "",
        },
        {
          id: 7,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "36.5%",
              x: "43.5%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["AdobeCC_Step1a_Image6a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: true,
            sequenceSources: [
              "AdobeCC_Step1a_Image6a.jpg",
              "AdobeCC_Step1a_Image6b.jpg",
              "AdobeCC_Step1a_Image6c.jpg",
              "AdobeCC_Step1a_Image6d.jpg",
              "AdobeCC_Step1a_Image6e.jpg",
              "AdobeCC_Step1a_Image6f.jpg",
              "AdobeCC_Step1a_Image6g.jpg",
              "AdobeCC_Step1a_Image6h.jpg",
              "AdobeCC_Step1a_Image6i.jpg",
              "AdobeCC_Step1a_Image6j.jpg",
              "AdobeCC_Step1a_Image6k.jpg",
              "AdobeCC_Step1a_Image6l.jpg",
              "AdobeCC_Step1a_Image6m.jpg",
              "AdobeCC_Step1a_Image6n.jpg",
              "AdobeCC_Step1a_Image6o.jpg",
            ],
          },
          screenReaderText:
            "In the same view, the user types meganb@contoso.com, as well as a hidden password. A purple pop-up points to a button that says “Sign In”.  ",
        },
        {
          id: 8,
          card: {
            transition: false,
            text: "Select the relevant asset",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "49%",
              x: "39%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["AdobeCC_Step1a_Image8.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A new white box appears titled “Adobe Creative Cloud”. The box has a search bar, and two horizontally oriented tabs: Files and Libraries. The Files tab is selected, and a purple pop-up points to an image titled “Event Promo 1.jpg.” ",
        },
        {
          id: 9,
          card: {
            transition: false,
            text:
              "In addition to pinning Creative Cloud assets, users can pin and share other Adobe documents, including PDFs.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "83%",
              x: "12.5%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["AdobeCC_Step1a_Image8.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, the “Event Promo 1.jpg” has been selected.  ",
        },
        {
          id: 10,
          card: {
            transition: false,
            text: "Click “Save” to pin the asset to the channel",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "68.5%",
              x: "61.4%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeCC_Step1a_Image10.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up points to a button titled “Save”. ",
        },
        {
          id: 11,
          card: {
            transition: false,
            text:
              "Click the info tab to view metadata via a flyout on the right rail",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "19.5%",
              x: "96.6%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeCC_Step1a_Image11.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The view has returned to the Event Planning channel, and a new tab has been added titled “Event Promo 1.jpg – Creative…” a purple pop-up is pointing to a small circular icon with an “i” in the center. The icon is located towards the upper right-hand corner of the page. The focus of the page is the “Event Promo 1.jpg” image.  ",
        },
        {
          id: 12,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "16.5%",
              x: "74.4%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["AdobeCC_Step1a_Image12.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a flyout has appeared on the right side of the screen with a summary of meta data on the “Event Promo 1.jpg” image. The meta information is in a vertical list and includes TYPE (Graphic), UPLOADED (9/19/2020, 1:39 PM), MODIFIED (9/19/2020, 1:39 PM), SIZE (6 KB), WIDTH (271px), HEIGHT (186px), and ACCESS (Public).  ",
        },
        {
          id: 13,
          card: {
            transition: false,
            text: "Chat with contributors directly in the flyout",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "6%",
              x: "84.8%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["AdobeCC_Step1a_Image13.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a flyout appears on the right-hand side of the screen with a chat box. A purple pop-up points to a chat dialogue box, prompting the user to type.  ",
        },
        {
          id: 14,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "96.5%",
              x: "96%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["AdobeCC_Step1a_Image14a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: true,
            sequenceSources: [
              "AdobeCC_Step1a_Image14a.jpg",
              "AdobeCC_Step1a_Image14b.jpg",
              "AdobeCC_Step1a_Image14c.jpg",
              "AdobeCC_Step1a_Image14d.jpg",
              "AdobeCC_Step1a_Image14e.jpg",
              "AdobeCC_Step1a_Image14f.jpg",
              "AdobeCC_Step1a_Image14g.jpg",
              "AdobeCC_Step1a_Image14h.jpg",
              "AdobeCC_Step1a_Image14i.jpg",
              "AdobeCC_Step1a_Image14j.jpg",
              "AdobeCC_Step1a_Image14k.jpg",
              "AdobeCC_Step1a_Image14l.jpg",
              "AdobeCC_Step1a_Image14m.jpg",
              "AdobeCC_Step1a_Image14n.jpg",
              "AdobeCC_Step1a_Image14o.jpg",
              "AdobeCC_Step1a_Image14p.jpg",
            ],
          },
          screenReaderText:
            "In the same view, a user types “Can we resize this for Instagram?” into the chat box. A purple pop-up points to a paper airplane icon that will send the message.",
        },
        {
          id: 15,
          card: {
            transition: false,
            text:
              "Conversation threads are also displayed in the main channel.",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "6.2%",
              x: "35.7%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["AdobeCC_Step1a_Image17.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up points to the “Posts” tab at the top of the Event Planning Teams channel.  ",
        },
        {
          id: 16,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "71.5%",
              x: "15.5%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["AdobeCC_Step1a_Image18.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The view of the Event Planning Teams channel has changed to the “Posts” view. There is a chat thread in the Event Planning channel. A purple box is highlighting the last message in the thread, indicating that the chat from the Event Promo 1.jpg also appears in this tab.  ",
        },
        {
          id: 17,
          card: {
            transition: false,
            text:
              "Click the asset thumbnail in the Teams channel to open the pinned asset",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "75.5%",
              x: "37.5%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeCC_Step1a_Image19.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up points to an Adobe Creative Cloud icon in the previously highlighted message. Clicking this icon will take users back to the “Event Promo 1.jpg – Creative…” tab  ",
        },
        {
          id: 18,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "83%",
              x: "4.5%",
            },
            beacon: {
              isVisible: false,
              position: "bottom",
            },
          },
          images: {
            name: ["AdobeCC_Step1a_Image17.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The user has clicked the Adobe Creative Cloud icon, and the view has switched back to the Event Promo 1.jpg tab view.  ",
        },
        {
          id: 19,
          card: {
            transition: false,
            text:
              "Users can also pin Creative Cloud Libraries directly in Teams channels, ensuring stakeholders can always view the latest brand guidelines.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "81%",
              x: "12.5%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["AdobeCC_Step1a_Image17.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same Event Promo 1.jpg tab view, there is a horizontal list of six tabs at the top of the Event Planning channel. Posts, Files, Wiki, Conference Planning, Freehand Whiteboard, and a plus sign to add a new tab. A purple pop-up points to the plus sign. ",
        },
        {
          id: 20,
          card: {
            transition: false,
            text: "Add a tab",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "6%",
              x: "71.9%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["AdobeCC_Step1a_Image17.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A white box appears with a header that reads “Add a tab” There is a grid style list of available apps. A purple pop-up points to the Adobe Creative Cloud icon.  ",
        },
        {
          id: 12,
          card: {
            transition: false,
            text: "Click “Libraries”",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "41%",
              x: "38.4%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeCC_Step1a_Image24.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A new white box appears titled “Adobe Creative Cloud”. The box has a search bar, and two horizontally oriented tabs: Files and Libraries. A purple pop-up points to the “Libraries” tab.  ",
        },
        {
          id: 21,
          card: {
            transition: false,
            text: "Select the library from the list",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "49%",
              x: "38.5%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeCC_Step1a_Image25.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The “Libraries” tab has been selected. A purple icon points to a thumbnail titled “Contoso brand guidelines”",
        },
        {
          id: 22,
          card: {
            transition: false,
            text: "Click “Save”",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "68.4%",
              x: "61.3%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["AdobeCC_Step1a_Image26.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, the “Contoso brand guideline” library has been selected, and a purple pop-up points to a button titled “Save”. ",
        },
        {
          id: 23,
          card: {
            transition: false,
            text: "View the library directly in Teams.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "88.3%",
              x: "12.5%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["AdobeCC_Step1a_Image27.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The view has returned to the Event Planning channel, and a new tab has been added titled “Contoso brand guidelines”. The page shows a list of tiles with various colors and corresponding color codes.",
        },
      ],
    },
    {
      id: 2,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Share links using message extensions",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text: "Start or find a chat thread",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "92.8%",
              x: "37.15%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeCC_Step1b_Image1.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "Use the lower menu bar to select the relevant asset",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "95.9%",
              x: "49.3%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["AdobeCC_Step1b_Image2.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 3,
          card: {
            transition: false,
            text:
              "Adobe Creative Cloud app supports sharing any Adobe file type in Teams, including .psd and .ai.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "83%",
              x: "87%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["AdobeCC_Step1b_Image3a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "Select the asset to add it to the chat",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "72%",
              x: "41%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeCC_Step1b_Image3b.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 5,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "95.9%",
              x: "85.7%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["AdobeCC_Step1b_Image4.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 6,
          card: {
            transition: false,
            text:
              "Once added, the Adobe Creative Cloud app will show key metadata for the asset, such as file name, size, last modified date, and publisher.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "81%",
              x: "87%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["AdobeCC_Step1b_Image5.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 7,
          card: {
            transition: false,
            text:
              "Once shared, users can open Creative Cloud assets in a browser directly from Teams.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "84%",
              x: "87%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["AdobeCC_Step1b_Image6.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 8,
          card: {
            transition: false,
            text:
              "Share a link directly in a Teams chat by pasting an asset link into the chat box",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "92%",
              x: "36.5%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeCC_Step1b_Image7.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 9,
          card: {
            transition: false,
            text:
              "Share a link directly in a Teams chat by pasting an asset link into the chat box",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "92%",
              x: "36.5%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeCC_Step1b_Image8a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 10,
          card: {
            transition: false,
            text: "Paste the link into the chat",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "97%",
              x: "65.15%",
            },
            beacon: {
              isVisible: false,
              position: "bottom",
            },
          },
          images: {
            name: ["AdobeCC_Step1b_Image8a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: true,
            sequenceSources: [
              "AdobeCC_Step1b_Image8a.jpg",
              "AdobeCC_Step1b_Image8b.jpg",
              "AdobeCC_Step1b_Image8c.jpg",
              "AdobeCC_Step1b_Image8d.jpg",
              "AdobeCC_Step1b_Image8e.jpg",
              "AdobeCC_Step1b_Image8f.jpg",
              "AdobeCC_Step1b_Image8g.jpg",
              "AdobeCC_Step1b_Image8h.jpg",
              "AdobeCC_Step1b_Image8i.jpg",
              "AdobeCC_Step1b_Image8j.jpg",
              "AdobeCC_Step1b_Image8k.jpg",
              "AdobeCC_Step1b_Image8l.jpg",
              "AdobeCC_Step1b_Image8m.jpg",
              "AdobeCC_Step1b_Image8n.jpg",
              "AdobeCC_Step1b_Image8o.jpg",
              "AdobeCC_Step1b_Image8p.jpg",
              "AdobeCC_Step1b_Image9.jpg",
            ],
          },
          screenReaderText: "",
        },
        {
          id: 11,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "95.7%",
              x: "85.7%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["AdobeCC_Step1b_Image10.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 12,
          card: {
            transition: false,
            text: "Click the link to open the asset in a browser.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "86%",
              x: "87.15%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["AdobeCC_Step1b_Image12.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
      ],
    },
    {
      id: 3,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Using connectors",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text:
              "Unite team workflows by using Microsoft connectors to share Creative Cloud and XD files directly in a Teams channel.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "81%",
              x: "87.15%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["AdobeCC_Step2a_Image1.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 2,
          card: {
            transition: false,
            text:
              "Click the ellipsis in the upper righthand corner of the Teams channel",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "5.9%",
              x: "97.4%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeCC_Step2a_Image1.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 3,
          card: {
            transition: false,
            text: "Select “Connectors” from the dropdown menu",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "32.5%",
              x: "88%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeCC_Step2a_Image3.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "Search Adobe Creative Cloud and click “Configure”",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "25.4%",
              x: "29.8%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeCC_Step2a_Image5a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 5,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "32%",
              x: "67.8%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["AdobeCC_Step2a_Image5a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: true,
            sequenceSources: [
              "AdobeCC_Step2a_Image5a.jpg",
              "AdobeCC_Step2a_Image5b.jpg",
              "AdobeCC_Step2a_Image5c.jpg",
              "AdobeCC_Step2a_Image6.jpg",
            ],
          },
          screenReaderText: "",
        },
        {
          id: 6,
          card: {
            transition: false,
            text: "Sign into Adobe Creative Cloud",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "42.5%",
              x: "31.2%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeCC_Step2a_Image7.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 7,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "30%",
              x: "43.15%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["AdobeCC_Step2a_Image8a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 8,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "36.5%",
              x: "43.4%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["AdobeCC_Step2a_Image8a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: true,
            sequenceSources: [
              "AdobeCC_Step2a_Image8a.jpg",
              "AdobeCC_Step2a_Image8b.jpg",
              "AdobeCC_Step2a_Image8c.jpg",
              "AdobeCC_Step2a_Image8d.jpg",
              "AdobeCC_Step2a_Image8e.jpg",
              "AdobeCC_Step2a_Image8f.jpg",
              "AdobeCC_Step2a_Image8g.jpg",
              "AdobeCC_Step2a_Image8h.jpg",
              "AdobeCC_Step2a_Image8i.jpg",
              "AdobeCC_Step2a_Image8j.jpg",
              "AdobeCC_Step2a_Image8k.jpg",
              "AdobeCC_Step2a_Image8l.jpg",
              "AdobeCC_Step2a_Image8m.jpg",
            ],
          },
          screenReaderText: "",
        },
        {
          id: 9,
          card: {
            transition: false,
            text:
              "Copy the link to the Adobe Creative Cloud asset and paste it into the Teams chat or channel",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "57%",
              x: "30.15%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeCC_Step2a_Image10.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 10,
          card: {
            transition: false,
            text:
              "Customize asset specific notifications for the Teams channel",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "70.5%",
              x: "31.7%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["AdobeCC_Step2a_Image12a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 11,
          card: {
            transition: false,
            text:
              "Asset owners manage the ability to control how their asset is shared, and can only connect assets within their own Creative Cloud account.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "81%",
              x: "13.15%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["AdobeCC_Step2a_Image12b.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 12,
          card: {
            transition: false,
            text: "Click “Save”",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "79%",
              x: "67%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["AdobeCC_Step2a_Image12b.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 13,
          card: {
            transition: false,
            text:
              "Once connected, channel members are notified any time there is an update to the asset via organized comment and response threads and accompanying deep links to the asset.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "78%",
              x: "86.15%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["AdobeCC_Step2a_Image14.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
      ],
    },
    {
      id: 4,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Receive personal bot notifications",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text:
              "The Adobe Creative Cloud bot provides key messages to help get users started.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "83%",
              x: "13.15%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["AdobeCC_Step2b_Image1.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "91.8%",
              x: "31%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["AdobeCC_Step2b_Image2.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText: "",
        },
        {
          id: 3,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "95.6%",
              x: "71.2%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["AdobeCC_Step2b_Image2.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: true,
            sequenceSources: [
              "AdobeCC_Step2b_Image2.jpg",
              "AdobeCC_Step2b_Image3.jpg",
            ],
          },
          screenReaderText: "",
        },
        {
          id: 4,
          card: {
            transition: false,
            text:
              "Sign in to the Adobe Creative Cloud account directly from the app to begin collaborating and sharing assets",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "30%",
              x: "43.3%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeCC_Step2b_Image4a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText: "",
        },
        {
          id: 5,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "36.5%",
              x: "43.5%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["AdobeCC_Step2b_Image4a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: true,
            sequenceSources: [
              "AdobeCC_Step2b_Image4a.jpg",
              "AdobeCC_Step2b_Image4b.jpg",
              "AdobeCC_Step2b_Image4c.jpg",
              "AdobeCC_Step2b_Image4d.jpg",
              "AdobeCC_Step2b_Image4e.jpg",
              "AdobeCC_Step2b_Image4f.jpg",
              "AdobeCC_Step2b_Image4g.jpg",
              "AdobeCC_Step2b_Image4h.jpg",
              "AdobeCC_Step2b_Image4i.jpg",
              "AdobeCC_Step2b_Image4j.jpg",
              "AdobeCC_Step2b_Image4k.jpg",
              "AdobeCC_Step2b_Image4l.jpg",
              "AdobeCC_Step2b_Image4m.jpg",
            ],
          },
          screenReaderText: "",
        },
        {
          id: 6,
          card: {
            transition: false,
            text:
              "Type “Notifications Off” or “Notifications On” to manage notifications within the bot channel",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "91.5%",
              x: "31.15%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeCC_Step2b_Image6.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 7,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "95.7%",
              x: "71.2%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["AdobeCC_Step2b_Image6.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: true,
            sequenceSources: [
              "AdobeCC_Step2b_Image6.jpg",
              "AdobeCC_Step2b_Image7a.jpg",
              "AdobeCC_Step2b_Image7b.jpg",
              "AdobeCC_Step2b_Image7c.jpg",
              "AdobeCC_Step2b_Image7d.jpg",
              "AdobeCC_Step2b_Image7e.jpg",
              "AdobeCC_Step2b_Image7f.jpg",
            ],
          },
          screenReaderText: "",
        },
        {
          id: 8,
          card: {
            transition: false,
            text:
              "Sign in and out of multiple accounts by typing “sign in” and “sign out” into the chat",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "91.5%",
              x: "31.15%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeCC_Step2b_Image9.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText: "",
        },
        {
          id: 9,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "95.7%",
              x: "71.3%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["AdobeCC_Step2b_Image9.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: true,
            sequenceSources: [
              "AdobeCC_Step2b_Image9.jpg",
              "AdobeCC_Step2b_Image11a.jpg",
              "AdobeCC_Step2b_Image11b.jpg",
              "AdobeCC_Step2b_Image11c.jpg",
              "AdobeCC_Step2b_Image12.jpg",
              "AdobeCC_Step2b_Image12.jpg",
              "AdobeCC_Step2b_Image12.jpg",
            ],
          },
          screenReaderText: "",
        },
        {
          id: 10,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "92%",
              x: "30.8%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["AdobeCC_Step2b_Image13b.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 11,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "84.5%",
              x: "33.4%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["AdobeCC_Step2b_Image9.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: true,
            sequenceSources: [
              "AdobeCC_Step2b_Image13b.jpg",
              "AdobeCC_Step2b_Image13c.jpg",
              "AdobeCC_Step2b_Image13d.jpg",
              "AdobeCC_Step2b_Image13e.jpg",
              "AdobeCC_Step2b_Image14.jpg",
            ],
          },
          screenReaderText: "",
        },
        {
          id: 12,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "30.5%",
              x: "42.8%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["AdobeCC_Step2b_Image15a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 13,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "37%",
              x: "43.5%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["AdobeCC_Step2b_Image9.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: true,
            sequenceSources: [
              "AdobeCC_Step2b_Image15a.jpg",
              "AdobeCC_Step2b_Image15b.jpg",
              "AdobeCC_Step2b_Image15c.jpg",
              "AdobeCC_Step2b_Image15d.jpg",
              "AdobeCC_Step2b_Image15e.jpg",
              "AdobeCC_Step2b_Image15f.jpg",
              "AdobeCC_Step2b_Image15g.jpg",
              "AdobeCC_Step2b_Image15h.jpg",
              "AdobeCC_Step2b_Image15i.jpg",
              "AdobeCC_Step2b_Image15j.jpg",
              "AdobeCC_Step2b_Image15k.jpg",
              "AdobeCC_Step2b_Image15l.jpg",
            ],
          },
          screenReaderText: "",
        },
        {
          id: 14,
          card: {
            transition: false,
            text:
              "Keep track of comments on your Creative Cloud assets and @mentions across Teams channels with Creative Cloud bot notifications.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "80%",
              x: "12.5%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["AdobeCC_Step2b_Image17.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 15,
          card: {
            transition: false,
            text:
              "Get questions answered without leaving Teams via the Help tab in the personal bot channel",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "6.5%",
              x: "21%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["AdobeCC_Step2b_Image18.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 9,
          card: {
            transition: false,
            text:
              "Head to Adobe Creative Cloud’s website via deep links for additional support.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "83%",
              x: "85.1%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["AdobeCC_Step2b_Image20.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
      ],
    },
    {
      id: 5,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Get the Adobe Creative Cloud app in Teams",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text:
              "To get the Adobe Creative Cloud app, head to the Teams Store",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "89.5%",
              x: "1.01%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeCC_Step3_Image1.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "Search the Teams Store",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "12.5%",
              x: "10.15%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["AdobeCC_Step3_Image2.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 3,
          card: {
            transition: false,
            text: "Click the Adobe Creative Cloud tile",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "13.2%",
              x: "42%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["AdobeCC_Step3_Image3a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: true,
            sequenceSources: [
              "AdobeCC_Step3_Image2.jpg",
              "AdobeCC_Step3_Image3a.jpg",
              "AdobeCC_Step3_Image3b.jpg",
            ],
          },
          screenReaderText: "",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "Install the app",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "28%",
              x: "31.3%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["AdobeCC_Step3_Image5.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 5,
          card: {
            transition: false,
            text:
              "Work with your Teams admin to pin the Adobe Creative Cloud app to the menu bar for your entire org, displaying the tools most relevant to your users.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "77%",
              x: "12.15%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["AdobeCC_Step3_Image6.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop app interface",
            sequence: false,
          },
          screenReaderText: "",
        },
      ],
    },
    {
      id: 6,
      sections: [
        {
          id: 0,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["AdobeCC_Step4_endcard.jpg"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
      ],
    },
  ],
};
